import getGapSize, { type GapSize } from '@/modules/common/utils/size.ts';
import type { Directive } from 'vue';

export default {
  mounted: (element, { value = 'm' }) => {
    element.style.marginRight = getGapSize(value);
  },
  updated(element, { value = 'm' }) {
    element.style.marginRight = getGapSize(value);
  },
} satisfies Directive<HTMLElement, GapSize>;
